var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',[_vm._l((_vm.paths),function(path,index){return _c('div',{key:path.id},[_c('span',{staticClass:"breadcrumb",on:{"click":function($event){return _vm.$emit('click', path.id)}}},[_vm._v(" "+_vm._s(path.name)+" ")]),(index < _vm.paths.length)?_c('span',{style:({
          fontSize: '1.1em',
          padding: '0 0.5em'
        })},[_vm._v(" » ")]):_vm._e()])}),(_vm.title)?_c('h4',[_vm._v(" "+_vm._s(_vm.title.name)+" ")]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }